
import React from 'react';
import { LocalizedContent } from '../utils/localization';

interface ProcessProps {
  content: LocalizedContent;
}

const Process: React.FC<ProcessProps> = ({ content }) => {
  return (
    <section className="py-16 bg-[#0A0A10]">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12 text-white font-future">{content.processTitle}</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {content.processSteps.map((step, index) => (
              <div key={index} className="bg-[#12121A] p-6 rounded-lg border border-purple-900/20 relative">
                <div className="absolute -top-4 -left-4 w-8 h-8 rounded-full bg-purple-600 flex items-center justify-center text-white font-bold">
                  {index + 1}
                </div>
                <h3 className="text-xl font-semibold mb-3 text-white mt-2">{step.title}</h3>
                <p className="text-gray-400">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
